(function () {
  const form = document.querySelector('[data-ff-cart]');
  if (!form) return;

  const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';

  async function setQty(item, quantity) {
    const key = item.getAttribute('data-ff-key');
    if (!key) return;
    item.classList.add('is-busy');
    try {
      const res = await fetch(changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      if (!res.ok) throw new Error('cart');
      window.location.reload();
    } catch (err) {
      item.classList.remove('is-busy');
      window.alert('Der Warenkorb konnte nicht geändert werden. Bitte erneut versuchen.');
    }
  }

  form.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-ff-qty]');
    if (!btn) return;
    event.preventDefault();
    const item = btn.closest('[data-ff-key]');
    const input = item && item.querySelector('[data-ff-qty-input]');
    if (!item || !input) return;
    const delta = Number(btn.getAttribute('data-ff-qty'));
    const next = delta === 0 ? 0 : Math.max(0, Number(input.value || 1) + delta);
    setQty(item, next);
  });

  form.addEventListener('change', (event) => {
    const input = event.target.closest('[data-ff-qty-input]');
    if (!input) return;
    const item = input.closest('[data-ff-key]');
    const next = Math.max(0, parseInt(input.value, 10) || 0);
    setQty(item, next);
  });
})();
